import { render, staticRenderFns } from "./TrailerTypeButton.vue?vue&type=template&id=b7b7527c"
import script from "./TrailerTypeButton.vue?vue&type=script&lang=js"
export * from "./TrailerTypeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports